"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePatterns = void 0;
const generateHorizontalPatterns_1 = require("./generateHorizontalPatterns");
const generateVerticalPatterns_1 = require("./generateVerticalPatterns");
const generatePatterns = (config, board) => {
    const horizontalPatterns = (0, generateHorizontalPatterns_1.generateHorizontalPatterns)(config, board);
    const verticalPatterns = (0, generateVerticalPatterns_1.generateVerticalPatterns)(config, board);
    return horizontalPatterns.concat(verticalPatterns);
};
exports.generatePatterns = generatePatterns;
